import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { ConversationActions } from 'store/actions';
import Header from 'components/Conversation/Message/Header';
import List from 'components/Conversation/Message/List';
import ReplyBox from 'components/Conversation/Message/ReplyBox';
import { CheckCircle2 } from 'lucide-react';
import toast from 'react-hot-toast';

let enhancer = connect(null, { ...ConversationActions })

function Show({ showConversation }) {
  const { encodedResourceId } = useParams();
  const [conversation, setConversation] = useState(null);
  const [sentMessage, setSentMessage] = useState(null);

  const { state, encoded_id: conversationId } = conversation?.attributes || {}

  useEffect(() => {
    if (!encodedResourceId) return
    setConversation(null)
    init()
  }, [encodedResourceId])

  async function init() {
    try {
      const { data } = await showConversation(encodedResourceId)
      setConversation(data)
    } catch (error: any) {
      toast.error(error.errors || 'Failed to load conversation')
    }
  }

  const closeConversation = () => {
    setConversation((_conversation) => ({
      ...(_conversation || {}),
      attributes: {
        ...(_conversation?.attributes || {}),
        state: 'closed',
      },
    }))
  }

  return (
    <div className="flex flex-col h-full">
      <Header conversation={conversation} />
      {conversationId && <List conversationId={conversationId} sentMessage={sentMessage} />}

      {conversation && (
        state === 'closed' ? (
          <div className="shrink-0 border-t border-base-200 px-4 py-4 flex items-center justify-center gap-2 text-sm text-base-content/50">
            <CheckCircle2 size={18} className="text-success-500 shrink-0" />
            This conversation has been resolved.
          </div>
        ) : (
          <ReplyBox conversationId={conversationId} onSent={setSentMessage} onClosed={closeConversation} />
        )
      )}
    </div>
  );
}

export default enhancer(Show);
